import { AxiosRequest, XMLrequest } from "../../../Url";
import { PostHandleTable } from "../../Tools/Requests";
import { defaultFieldInfo, getModalSectionID, getRightsData } from "../../Tools/Tools";
import { CreateCollapsibleRecords } from "../GridTools/collapsibleRecordsTools";
import { parseColumns } from "../GridTools/parseColumnTools";

export async function departmentsGrid(grid, source, props, data) {
  let json = await PostHandleTable(props.Module, "2790", undefined, props.SectionID);
  source.onHandleRequest = HandleRequest(props);
  //создание стилей для сворачивающихся записей
  source.CreateCollapsibleRecords = CreateCollapsibleRecords;

  grid.setUnderlineCell = (col, div) => {
    if (col.fieldName !== "Title" || col.title !== "Организация") return;
    const id = source.getFieldValueSync("Name");
    if (!id || id < 0) return;
    div.classList.add("grid-cell-inner-underline");
  };

  await source.open();

  source.setKeyFieldName("Code");

  //создание дефолтных полей()
  let columns = {
    title: [
      {
        fieldName: "Code",
        title: "Код",
        width: 120,
        level: 0,
        collapseRecord: true,
        fieldInfo: { ...defaultFieldInfo },
      },
      {
        fieldName: "Title",
        title: "Организация",
        width: 200,
        level: 0,
        fieldInfo: { ...defaultFieldInfo },
      },
      {
        fieldName: "Title",
        title: "Название",
        width: 200,
        level: 1,
        fieldInfo: { ...defaultFieldInfo },
      },
      {
        fieldName: "KeyNo",
        title: "Краткий код",
        width: 120,
        level: 1,
        fieldInfo: { ...defaultFieldInfo },
      },
      {
        fieldName: "DepTypes",
        title: "Тип подразделения",
        width: 120,
        level: 1,
        fieldInfo: { ...defaultFieldInfo, EditStyle: 32 },
      },
      {
        fieldName: "Options",
        title: "Параметры отдела",
        width: 120,
        level: 1,
        fieldInfo: { ...defaultFieldInfo, EditStyle: 32 },
      },
    ],
  };

  //парсинг полей запроса GetTableLayout
  if (json) {
    source.rights = getRightsData(json.Rights);

    columns = parseColumns(json, { inputColumns: columns });
    grid.setColumns(columns);
  } else grid.setColumns(columns);

  if (data.setSelectedRecord) {
    source.onRecordIndexChanged = async function (source) {
      data.setSelectedRecord(source.getFieldTextSync("ID"));
    };

    if (data.Pages && json.Pages) {
      data.Pages.current = json.Pages.split("\r\n").map((page) => {
        return { Caption: page };
      });
    }
  }

  source.onRecordCollapsed = async function (event) {
    let RecordIndex;
    if (event.currentTarget !== undefined) {
      RecordIndex = event.currentTarget.getAttribute("recordindex");
    } else {
      RecordIndex = await event;
    }
    let params = new Map();
    params
      .set("prefix", props.Module)
      .set("comand", "RecordCollapsed")
      .set("SectionID", props.SectionID)
      .set("ObjType", "2790")
      .set("RecordIndex", RecordIndex);
    AxiosRequest(true, params);
    await grid.refreshSource("!");
    if (data.setCountRecords) data.setCountRecords(source.recordCount);
  };

  await grid.setSource(source);

  if (props.ID) await grid.refreshSource(props.ID);
  if (data.setSelectedRecord) {
    data.setSelectedRecord(source.getFieldTextSync("ID"));
  }

  await grid.updateGridSize();
}

function HandleRequest(props) {
  return function onHandleRequest(request) {
    const params = new Map();
    params
      .set("prefix", props.Module)
      .set("comand", "HandleTable")
      .set("ObjType", "2790")
      .set("SectionID", props.SectionID)
      .set("All");
    return AxiosRequest(true, params, request);
  };
}
